import catalogHoursGateAtom from "@/atoms/catalog-hours-gate"
import { refreshApiData } from "@/hooks/use-api-polling"
import { useStorefrontScheduling } from "@/hooks/use-storefront-scheduling"
import { setCatalogWindow } from "@/lib/fetch-api"
import { useSetAtom } from "jotai"
import { useEffect } from "react"

/**
 * Keeps the menu aligned with the scheduling state: a closed store whose
 * channel schedules gets the catalog of the target window (`?window=`), and
 * any channel with scheduling stops hiding items by the current hour (D16).
 * Under `futureWindows` the hour filter is off outright — the customer picks a
 * future day, so "fechado agora" never decides what is on the shelf (§9.2).
 */
export function useSchedulingCatalog(): void {
  const { known, catalogWindow, schedulableChannels, futureWindows } = useStorefrontScheduling()
  const setHoursGate = useSetAtom(catalogHoursGateAtom)
  const hasScheduling = futureWindows || schedulableChannels.length > 0

  useEffect(() => {
    setHoursGate(!known || !hasScheduling)
  }, [known, hasScheduling, setHoursGate])

  useEffect(() => {
    if (!known) return
    if (setCatalogWindow(catalogWindow)) void refreshApiData()
  }, [known, catalogWindow])
}
